/**
 *
 * layout_scrollingSitemap.js
 *
 *
 */
(() => {


	/**************************************************************
	 * scrollingSitemap
	**************************************************************/
	const sitemapScrolling = new CustomEvent('sitemapScrolling');
	const targets          = document.querySelectorAll('.l-sitemap,.l-sitemap__contents');

	for ( let i = 0; i < targets.length; i++ ) {
		targets[i].addEventListener('scroll',() => {
			window.dispatchEvent( sitemapScrolling );
		})
	}


})();
